import { usePathname } from 'next/navigation';

import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import { useFormattedBookingDetails } from 'reservations/booking/hooks/useFormattedBookingDetails';
import { useIsWaitlist } from 'reservations/booking/providers/BookingProvider';
import { JOIN_URL_BASE_PATH } from 'reservations/guests/constants';

interface Props {
  inviteToSplit?: boolean;
}

export const useGuestInviteSMSFields = ({
  inviteToSplit = false
}: Props = {}) => {
  const pathname = usePathname();
  const restaurantName = useRestaurantName();
  const isWaitlist = useIsWaitlist();
  const { formattedDateAndTime, formattedPositionInLine } =
    useFormattedBookingDetails();

  const title = `Join my party at ${restaurantName}.`;
  const text = `${
    inviteToSplit
      ? `Join my party and split the bill with me at ${restaurantName}`
      : `Click on this link to join my party at ${restaurantName}`
  }${
    isWaitlist
      ? `. We're ${formattedPositionInLine}.`
      : ` on ${formattedDateAndTime}.`
  }`;
  const url = `/${JOIN_URL_BASE_PATH}${pathname}/join${inviteToSplit ? '?inviteToSplit=true' : ''}`;

  return {
    title,
    text,
    url
  };
};
